import { Component, OnInit, ViewChild, ChangeDetectorRef , ElementRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CtvetserviceService } from './ctvetservice.service';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { ToastrService } from 'ngx-toastr';



interface Student {
  id: number;
  fullname: string;
  vmsId: string;
  course: string;
  groupName: string;
  date: string;
}

interface Course {
  id: number;
  name: string;
}


@Component({
  selector: 'app-ctvetatendance',
  templateUrl: './ctvetatendance.component.html',
  styleUrls: ['./ctvetatendance.component.css']
})
export class CtvetatendanceComponent implements OnInit {
  students: Student[] = [];
  courses: Course[] = [
    { id: 1, name: 'Garment Making' },
    { id: 2, name: 'English Language' },
    { id: 3, name: 'Information Communication Technology' }
    // more will be added here
  ];
    selectedStudent: Student | null = null;
  selectedCourse: Course | null = null;
  date: string = '';
  group: string = '';
  status: string = '';
  capturedImage: string | null = null;


  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

      // Webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();

  submitted = false;


    public loading = false;
    constructor(private breakpointObserver: BreakpointObserver, private router: Router,
       private ctvetService: CtvetserviceService, private toaster: ToastrService){
    }


    loadStudents() {
      this.ctvetService.viewAllStudents().subscribe(
        (data: Student[]) => {
          this.students = data;
        },
        (error) => {
          console.error('Error fetching students:', error);
          // Handle error (e.g., show error message to user)
        }
      );
    }
  
  

  ngOnInit() {
    // Fetch students on component initialization
    this.ctvetService.viewAllStudents().subscribe(
      (students) => {
        this.students = students;
      },
      (error) => {
        console.error('Error fetching students:', error);
      }
    );
  }


  captureImage(): void {
    // Trigger the snapshot
    this.trigger.next();
  }

  handleImage(webcamImage: WebcamImage): void {
    this.capturedImage = webcamImage.imageAsDataUrl;
  }

  retakeImage(): void {
    this.capturedImage = null;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  onSubmit() {
    this.submitted = true; 
    const attendanceData = {
      fullname: this.selectedStudent?.fullname,
      vmsId: this.selectedStudent?.vmsId,
      date: this.date,
      course: this.selectedCourse?.name,
      group: this.selectedStudent?.groupName,
      status: this.status
    };
  
    if (this.isFormValid()) {
      // Random string of 5 characters
      const randomCode = Math.random().toString(36).substring(2, 7); 
      // Use the student's fullname as the filename, with `.jpg` extension
      const imageFileName = `${this.selectedStudent.fullname}_${randomCode}.jpg`;
      const imageFile = this.dataURItoFile(this.capturedImage, imageFileName);
      this.ctvetService.submitCtvetAttendance(attendanceData, imageFile).subscribe(
        (response) => {
          console.log('Attendance saved successfully', response);
          this.toaster.success('success', 'CTVET Attendance saved successfully',{
            positionClass: 'toast-top-center',
          });
          setTimeout(()=>{
            this.router.navigate(['/ctvet-dashboard']);
          }, 3000)
        },
        (error) => {
          console.error('Error saving attendance:', error);
          this.toaster.error('Error saving attendance:', error,{
            positionClass: 'toast-top-center',
          });
        }
      );
    }
  }
  
// Helper function to convert base64 image data to File
dataURItoFile(dataURI: string, fileName: string): File {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });
  return new File([blob], fileName, { type: mimeString });
}


isFormValid() {
  // Check if the form is valid
  return this.selectedStudent && this.selectedCourse && this.status && this.date && this.capturedImage;
}

}
